import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=6b8f49bc"
import script from "./protocol.vue?vue&type=script&lang=js"
export * from "./protocol.vue?vue&type=script&lang=js"
import style0 from "./protocol.vue?vue&type=style&index=0&id=6b8f49bc&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8f49bc')) {
      api.createRecord('6b8f49bc', component.options)
    } else {
      api.reload('6b8f49bc', component.options)
    }
    module.hot.accept("./protocol.vue?vue&type=template&id=6b8f49bc", function () {
      api.rerender('6b8f49bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loginreg/protocol.vue"
export default component.exports